import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManagerRecommendationComponent } from './manager-recommendation.component';



@NgModule({
  declarations: [ManagerRecommendationComponent],
  imports: [
    CommonModule
  ],
  exports: [
    ManagerRecommendationComponent
  ]
})
export class ManagerRecommendationModule { }
